import { useEffect } from 'react';
const VnDocumentTitle = (title) => {
    useEffect(() => {
        document.title = title;
    }, [title]);
};
export default VnDocumentTitle;
